import Swiper from 'swiper'
import { Navigation, Thumbs } from 'swiper/modules'

export default class MainGallery {
	private mainSwiper: Swiper | null = null
	private thumbsSwiper: Swiper | null = null

	private featuredImage: HTMLElement | null = null
	private featuredImageClone: HTMLElement | null = null
	private featuredImagePlaceholder: Comment | null = null

	private mobileBreakpoint = 1024
	private isMobileLayout: boolean | null = null

	constructor() {
		this.init()
		window.addEventListener('resize', this.handleResize.bind(this))
	}

	init() {
		this.featuredImage = document.querySelector('.featured__image') as HTMLElement
		if (!this.featuredImage) return

		// Placeholder to restore featured image on desktop
		this.featuredImagePlaceholder = document.createComment('featured-image-placeholder')
		this.featuredImage.parentNode?.insertBefore(
			this.featuredImagePlaceholder,
			this.featuredImage
		)

		this.updateLayout(true)
	}

	handleResize() {
		this.updateLayout()
	}

	updateLayout(force = false) {
		const isMobile = window.innerWidth <= this.mobileBreakpoint

		// Prevent unnecessary rebuilds
		if (!force && this.isMobileLayout === isMobile) return
		this.isMobileLayout = isMobile

		this.destroySwipers()

		const mainSlider = document.querySelector('.product-slider') as HTMLElement
		const thumbsSlider = document.querySelector('.js-gallery-thumbs') as HTMLElement

		if (!mainSlider || !thumbsSlider || !this.featuredImage) return

		const mainWrapper = mainSlider.querySelector('.swiper-wrapper')
		const thumbsWrapper = thumbsSlider.querySelector('.swiper-wrapper')

		if (!mainWrapper || !thumbsWrapper) return

		if (isMobile) {
			this.moveFeaturedIntoMain(mainWrapper)
			this.addFeaturedToThumbs(thumbsWrapper)
		} else {
			this.restoreFeaturedToDesktop()
		}

		this.initSwipers(mainSlider, thumbsSlider)
	}

	/* =======================
	   SWIPER INIT / DESTROY
	======================= */

	initSwipers(mainSlider: HTMLElement, thumbsSlider: HTMLElement) {
		// Init thumbs FIRST
		this.thumbsSwiper = new Swiper(thumbsSlider, {
			slidesPerView: 4.2,
			spaceBetween: 10,
			watchSlidesProgress: true,
			// loop: true,
			modules: [Thumbs],
			breakpoints: {
				1024: {
					spaceBetween: 12,
					slidesPerView: 5.3
				}
			}
		})

		// Init main
		this.mainSwiper = new Swiper(mainSlider, {
			slidesPerView: 1,
			// loop: true,
			navigation: {
				prevEl: mainSlider.querySelector('.swiper-navigate-prev') as HTMLButtonElement,
				nextEl: mainSlider.querySelector('.swiper-navigate-next') as HTMLButtonElement,
			},
			thumbs: {
				swiper: this.thumbsSwiper,
			},
			modules: [Navigation, Thumbs],
		})
	}

	destroySwipers() {
		if (this.mainSwiper) {
			this.mainSwiper.destroy(true, true)
			this.mainSwiper = null
		}

		if (this.thumbsSwiper) {
			this.thumbsSwiper.destroy(true, true)
			this.thumbsSwiper = null
		}
	}

	/* =======================
	   MOBILE
	======================= */

	moveFeaturedIntoMain(wrapper: Element) {
		if (this.featuredImage?.classList.contains('swiper-slide')) return

		this.featuredImage?.classList.add('swiper-slide')
		// @ts-ignore
		wrapper.prepend(this.featuredImage)
	}

	addFeaturedToThumbs(wrapper: Element) {
		if (this.featuredImageClone) return

		this.featuredImageClone = this.featuredImage!.cloneNode(true) as HTMLElement
		this.featuredImageClone.classList.add(
			'swiper-slide',
			'featured__image--clone'
		)

		wrapper.prepend(this.featuredImageClone)
	}

	/* =======================
	   DESKTOP
	======================= */

	restoreFeaturedToDesktop() {
		// Restore original featured image
		if (
			this.featuredImagePlaceholder &&
			this.featuredImage?.classList.contains('swiper-slide')
		) {
			this.featuredImage.classList.remove('swiper-slide')
			this.featuredImage.style.removeProperty('width')
			this.featuredImage.style.removeProperty('transform')

			this.featuredImagePlaceholder.parentNode?.insertBefore(
				this.featuredImage,
				this.featuredImagePlaceholder
			)
		}

		// Remove thumbs clone
		if (this.featuredImageClone) {
			this.featuredImageClone.remove()
			this.featuredImageClone = null
		}
	}
}
